import { setCookie, clearCookie } from "../../../_global/js/cookieHelper";

const FEATURE_BRANCH_MANAGER_COOKIE_NAME = "branch";
const FEATURE_BRANCH_MANAGER_EXPIRY_TIME = 0.0416; // 1 hour expressed as fraction of a day (1/24).

const FEATURE_BRANCH_RESET_SELECTOR = '[data-click="featureBranchReset"]';
const FEATURE_BRANCH_SET_SELECTOR = '[data-click="featureBranchSet"]';

export default class FeatureBranchSwitcher {
    constructor(control) {
        this.component = control;

        const reset = control.querySelector(FEATURE_BRANCH_RESET_SELECTOR);
        if (reset) {
            reset.addEventListener("click", () => {
                this.resetToDefaultBranch();
            });
        }

        const set = control.querySelectorAll(FEATURE_BRANCH_SET_SELECTOR);
        set.forEach((setControl) => {
            setControl.addEventListener("click", (event) => {
                this.setFeatureBranch(event.target.dataset.branch);
            });
        });
    }

    setFeatureBranch(value) {
        setCookie(
            FEATURE_BRANCH_MANAGER_COOKIE_NAME,
            value,
            FEATURE_BRANCH_MANAGER_EXPIRY_TIME
        );
        window.location.reload();
    }

    resetToDefaultBranch() {
        clearCookie(FEATURE_BRANCH_MANAGER_COOKIE_NAME);
        window.location.reload();
    }
}
